import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import CategoryTabs from './CategoryTabs';

const ProjectList = () => {
  const data = useStaticQuery(graphql`
  query blogIndex {
    allMdx {
      edges {
        node {
          id
          body
          frontmatter {
            briefing
            about
            client
            targetAudience
            category
            title
            path
            category
            featuredImage {
              childImageSharp {
                fluid(quality: 90) {
                  aspectRatio
                  base64
                  sizes
                  src
                  srcSet
                }
              }
            }
          }
        }
      }
    }
  }
  
`)

  const { edges: projects } = data.allMdx
  return (
    <div id="main">
      <div className="projects" id="projects">
        <div className="inner">
          <CategoryTabs projects={projects} />
        </div>
      </div>
    </div>

  );
}

export default ProjectList;
